import DatitudeNewsletter from '../components/datitude-newsletter'

document.addEventListener('DOMContentLoaded', () => {
  DatitudeNewsletter().init()
})
